export const HUB_BASE = '/hub'

const routesConstants = {
  HOME: HUB_BASE,
  LIBRARY: `${HUB_BASE}/library`,
  LIBRARY3: `${HUB_BASE}/library3`,
  READER: `${HUB_BASE}/reader`,
  READER_ID: `${HUB_BASE}/reader/:id`,
  BIBLIOTECA: `${HUB_BASE}/biblioteca`,
  SPANISH_READER: `${HUB_BASE}/spanish-reader`,
  SPANISH_READER_ID: `${HUB_BASE}/spanish-reader/:id`,
  CAMINOS: `${HUB_BASE}/caminos`,
  CAMINOS_READER: `${HUB_BASE}/caminos-reader`,
  CAMINOS_READER_ID: `${HUB_BASE}/caminos-reader/:id`,
  TEXAS_ELAR: `${HUB_BASE}/texas-elar`,
  TEXAS_ELAR_READER: `${HUB_BASE}/texas-elar-reader`,
  TEXAS_ELAR_READER_ID: `${HUB_BASE}/texas-elar-reader/:id`,
  TEXAS_SLAR: `${HUB_BASE}/texas-slar`,
  TEXAS_SLAR_READER: `${HUB_BASE}/texas-slar-reader`,
  TEXAS_SLAR_READER_ID: `${HUB_BASE}/texas-slar-reader/:id`,
  LIBRARY_3_READER: `${HUB_BASE}/reader3`,
  LIBRARY_3_READER_ID: `${HUB_BASE}/reader3/:id`,

  SOUNDS: `${HUB_BASE}/sounds`,
  SOUNDS_ID: `${HUB_BASE}/sounds/:id`,
  SONIDOS: `${HUB_BASE}/sonidos`,
  SONIDOS_ID: `${HUB_BASE}/sonidos/:id`,

  THEATER: `${HUB_BASE}/theater`,
  THEATER_ID: `${HUB_BASE}/theater/:id`,

  TEACHER_GUIDE: `${HUB_BASE}/teacher-guide`,
  TEACHER_GUIDE_CHAPTER: `${HUB_BASE}/teacher-guide/:chapter`,

  AVATAR_BUILDER: `${HUB_BASE}/avatar-builder`,
}

export default routesConstants
